import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  const scrollToDownload = () => {
    const downloadSection = document.getElementById('download');
    if (downloadSection) {
      downloadSection.scrollIntoView({ behavior: 'smooth' });
    }

    // Track button click
    if (window.gtag) {
      window.gtag('event', 'click', {
        event_category: 'engagement',
        event_label: 'hero_cta_button'
      });
    }
  };

  return (
    <section className="hero" role="banner" aria-label="ChoreTap main hero section">
      <div className="hero-background" aria-hidden="true">
        <div className="hero-shape hero-shape-1"></div>
        <div className="hero-shape hero-shape-2"></div>
        <div className="hero-shape hero-shape-3"></div>
      </div>

      <div className="container">
        <div className="hero-content">
          <header className="hero-text">
            <div className="hero-logo">
              <img 
                src="/choretap-logo.png" 
                alt="ChoreTap - Family Chore Management App Logo" 
                width="120" 
                height="40"
                loading="eager"
              />
            </div>
            <h1 className="hero-title">
              Make Chores Fun with <span className="highlight">ChoreTap</span>
            </h1>
            <p className="hero-subtitle">
              Transform household chores into engaging tasks that teach kids responsibility
              while helping parents manage family life effortlessly.
            </p>
            <nav className="hero-buttons" role="navigation" aria-label="Primary actions">
              <button 
                onClick={scrollToDownload} 
                className="btn btn-primary btn-large"
                aria-describedby="download-description"
              >
                Download Now - Free
              </button>
              <a 
                href="#features" 
                className="btn btn-secondary btn-large"
                aria-label="Learn more about ChoreTap features and benefits"
              >
                Discover Features
              </a>
            </nav>
            <div id="download-description" className="sr-only">
              Download ChoreTap free for iOS and Android to start your family's chore management journey
            </div>
            <div className="hero-beta">
              <p>
                🎉 <strong>Join our Beta Program!</strong> Email{' '}
                <a 
                  href="mailto:support@choretap.app?subject=Beta Program Interest"
                  aria-label="Email support for beta program access"
                >
                  support@choretap.app
                </a>{' '}
                for early access
              </p>
            </div>
          </header>

          <div className="hero-image" role="img" aria-label="ChoreTap mobile app interface preview">
            <div className="phone-mockup">
              <div className="phone-frame">
                <div className="phone-screen">
                  <div className="app-preview">
                    <div className="logo-display">
                      <img 
                        src="/logo512.svg" 
                        alt="ChoreTap App Interface - Family Chore Management Dashboard" 
                        className="phone-logo"
                        width="200"
                        height="200"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
